<script setup>
defineProps({
  item: {
    type: Object,
    required: true,
  },
});
</script>

<template>
  <a class="flex group relative shadow-sm bg-white" :href="item.url">
    <div
      class="transition ease-in-out duration-300 overflow-hidden rounded-xl group-hover:brightness-75 ">
      <img
        :src="item.image"
        class="w-full aspect-1 h-full object-cover"
        loading="lazy"
      />
    </div>
    <div class="absolute inset-0 flex flex-col justify-end z-20">
      <div
        class="rounded-xl transition-all ease-in-out group-hover:transform duration-300 p-4 group-hover:py-10 bg-gradient-to-b from-transparent to-black/75 z-0"
      >
        <span class="text-sm text-white font-bold">{{ item.name }}</span>
      </div>
    </div>
  </a>
</template>
